import React, { useState } from 'react';
import { apiRequest } from '../../api/api';
import MarketingBudgetModal from '../../components/modals/MarketingBudgetModal';
import BudgetSummaryCards from './components/BudgetSummaryCards';

const MarketingBudget = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleSave = () => {
    setEditingData(null);
    // Veri yenileme trigger'ı
    setRefreshTrigger(prev => prev + 1);
  };

  const handleEdit = (entries) => {
    setEditingData(entries);
    setIsModalOpen(true);
  };

  const handleDelete = async (entries) => {
    if (!window.confirm('Seçili bütçeyi (tüm satırlarıyla) silmek istiyor musunuz?')) return;

    try {
      const idsToDelete = (entries || [])
        .filter(e => e.id && !isNaN(e.id) && Number.isInteger(Number(e.id)))
        .map(e => e.id);

      if (idsToDelete.length > 0) {
        await apiRequest('/marketing-budget/registries/bulk_delete/', {
          method: 'POST',
          body: JSON.stringify({ ids: idsToDelete })
        });
      }

      setRefreshTrigger(prev => prev + 1);
      alert('Seçili bütçe silindi.');
    } catch (error) {
      alert('Silme sırasında bir hata oluştu.');
    }
  };

  const handleCreateFromPlanning = (entries) => {
    // Seçilen kayıtları kopyalayıp yeni kayıt olarak hazırla
    const copiedData = entries.map(entry => ({
      ...entry,
      id: undefined, // Yeni kayıt olacak
      budgettype: 2, // Gerçekleşen ID'si
      budgettype_name: 'Gerçekleşen',
      budgettype_id: 2
    }));

    setEditingData(copiedData);
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Budget Management
          </h1>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
            Marketing bütçe yönetimi ve takibi
          </p>
        </div>

        {/* Bütçe Kayıtları Özeti */}
        <BudgetSummaryCards
          onEdit={handleEdit}
          onDelete={handleDelete}
          onNew={() => {
            setEditingData(null);
            setIsModalOpen(true);
          }}
          onCreateFromPlanning={handleCreateFromPlanning}
          refreshTrigger={refreshTrigger}
        />
      </div>

      {/* Budget Entry Modal */}
      <MarketingBudgetModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingData(null);
        }}
        onSave={handleSave}
        editingData={editingData}
      />
    </div>
  );
};

export default MarketingBudget;
